import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setHeaderActions, resetHeaderActions } from 'app/shared-components/store/headerSlice';

type ButtonHeaderAction = {
  title: string;
  type: 'button';
  callback: () => void;
  disabled?: boolean;
  icon?: JSX.Element | string;
  className?: string;
  tooltip?: string;
  square?: boolean;
  pro?: boolean;
};

type SelectHeaderAction = {
  title: string;
  type: 'select';
  callback: () => void;
  defaultValue: string;
  options: { label: string; value: string }[];
  pro?: boolean;
};

type DropdownHeaderAction = {
  type: 'dropdown';
  title: string;
  label?: string;
  className?: string;
  icon: JSX.Element | string;
  items: {
    id?: string;
    callback?: () => void;
    title: string;
    type?: string;
    url?: string;
  }[];
};

type TextTutorialHeaderAction = {
  title: string;
  type: 'text_tutorial';
  resource: string;
};

type VideoTutorialHeaderAction = {
  title: string;
  type: 'video_tutorial';
  url: string;
};

type HeaderAction =
  | ButtonHeaderAction
  | SelectHeaderAction
  | DropdownHeaderAction
  | TextTutorialHeaderAction
  | VideoTutorialHeaderAction;

export default function useHeaderActions(actions: HeaderAction[]): void {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (actions?.length > 0) dispatch(setHeaderActions(actions));
    if (!actions?.length) dispatch(resetHeaderActions());

    return () => {
      dispatch(resetHeaderActions());
    };
  }, [dispatch, navigate, actions]);
}
